import { render } from "./Profile.vue?vue&type=template&id=5bfd44d7&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=5bfd44d7&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfd44d7"]])

export default __exports__